<template>
  <div class="support-wrapper">
    <div>
      <span>{{
          $t('Support.Address', {
            companyName: $company.created_by_company.customization_enabled ? $company.created_by_company.legal_company_name : ($company.customization_enabled ? $company.legal_company_name : CyberGuru.LegalName)
            , VAT: $company.created_by_company.customization_enabled ? $company.created_by_company.vat : ($company.customization_enabled ? $company.vat : CyberGuru.VAT),
            registeredOffice: $company.created_by_company.customization_enabled ? $company.created_by_company.registered_office || '-' : ($company.customization_enabled ? $company.registered_office || '-' : CyberGuru.RegisteredOffice)
          })
        }}
      </span>
    <!--<span>{{ $t('Support.Mail') }} <a :href="mailTo">{{ placeholderMailTo }}</a></span>-->
    </div>
    <div v-if="$appVersion !== '_APP_VERSION' || (!($company.created_by_company.customization_enabled) && !$company.customization_enabled)">
      <span v-if="$appVersion !== '_APP_VERSION'" class="font-bold">V{{ $appVersion }}</span>
      <span v-if="!$company.created_by_company.customization_enabled && !$company.customization_enabled" class="ml-3 italic">{{ $t('Support.Copyright', {currentYear: $dateTime.now().toFormat('yyyy')}) }}</span>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import {CyberGuru} from "@/common/constants";

export default defineComponent({
  data() {
    return {
      CyberGuru
    };
  }
});

</script>

<style lang='scss' scoped>
.support-wrapper {
  @apply bg-extra-light text-custom-contrastPrimary flex flex-col lg:flex-row lg:items-center lg:justify-between px-11 py-8 text-center space-y-5 lg:space-y-0 lg:text-left;
  & span {
    @apply text-xs text-black
  }
}
</style>